import dayjs from "dayjs";
import {Organization} from "../api-client";
import {ComponentType} from "react";
import MedicalStaffForm from "../components/medicalStaff/MedicalStaffForm";
import MedicalStaffFormForeign from "../components/medicalStaff/MedicalStaffFormForeign";
import logger from "../utils/logger";

export const calculateTotalPrice = (price: number, discount: number, laboratoryPrice: number, cb: Function) => {
    if (!isNaN(price) && !isNaN(discount)) {
        const priceCalculation = price - (price * (discount / 100));

        cb(priceCalculation);
    } else {
        cb(0);
    }
};

export function transliterateCyrillicToLatin(text: string): string {
    if (!text) {
        return '';
    }

    const mapping: { [key: string]: string } = {
        'А': 'A', 'а': 'a',
        'Б': 'B', 'б': 'b',
        'В': 'V', 'в': 'v',
        'Г': 'G', 'г': 'g',
        'Д': 'D', 'д': 'd',
        'Е': 'E', 'е': 'e',
        'Ж': 'Zh', 'ж': 'zh',
        'З': 'Z', 'з': 'z',
        'И': 'I', 'и': 'i',
        'Й': 'Y', 'й': 'y',
        'К': 'K', 'к': 'k',
        'Л': 'L', 'л': 'l',
        'М': 'M', 'м': 'm',
        'Н': 'N', 'н': 'n',
        'О': 'O', 'о': 'o',
        'П': 'P', 'п': 'p',
        'Р': 'R', 'р': 'r',
        'С': 'S', 'с': 's',
        'Т': 'T', 'т': 't',
        'У': 'U', 'у': 'u',
        'Ф': 'F', 'ф': 'f',
        'Х': 'H', 'х': 'h',
        'Ц': 'Ts', 'ц': 'ts',
        'Ч': 'Ch', 'ч': 'ch',
        'Ш': 'Sh', 'ш': 'sh',
        'Щ': 'Sht', 'щ': 'sht',
        'Ъ': 'A', 'ъ': 'a',
        'Ь': 'Y', 'ь': 'y',
        'Ю': 'Yu', 'ю': 'yu',
        'Я': 'Ya', 'я': 'ya',
    };

    return text.split('').map((char) => mapping[char] || char).join('');
}

export function transliterateLatinToCyrillic(text: string | undefined): string {
    if (text === undefined) {
        return '';
    }
    const reverseMapping: { [key: string]: string } = {
        'A': 'А', 'a': 'а',
        'B': 'Б', 'b': 'б',
        'V': 'В', 'v': 'в',
        'G': 'Г', 'g': 'г',
        'D': 'Д', 'd': 'д',
        'E': 'Е', 'e': 'е',
        'Zh': 'Ж', 'zh': 'ж',
        'Z': 'З', 'z': 'з',
        'I': 'И', 'i': 'и',
        'Y': 'Й', 'y': 'й',
        'K': 'К', 'k': 'к',
        'L': 'Л', 'l': 'л',
        'M': 'М', 'm': 'м',
        'N': 'Н', 'n': 'н',
        'O': 'О', 'o': 'о',
        'P': 'П', 'p': 'п',
        'R': 'Р', 'r': 'р',
        'S': 'С', 's': 'с',
        'T': 'Т', 't': 'т',
        'U': 'У', 'u': 'у',
        'F': 'Ф', 'f': 'ф',
        'H': 'Х', 'h': 'х',
        'Ts': 'Ц', 'ts': 'ц',
        'Ch': 'Ч', 'ch': 'ч',
        'Sh': 'Ш', 'sh': 'ш',
        'Sht': 'Щ', 'sht': 'щ',
        'Yu': 'Ю', 'yu': 'ю',
        'Ya': 'Я', 'ya': 'я',
    };


    const regExp = new RegExp(Object.keys(reverseMapping).sort((a, b) => b.length - a.length).join('|'), 'gi');

    return text.replace(regExp, match => reverseMapping[match] || match);
}


export function validateEgnWithBirthDate(egn: string, birthDate: any) {
    if (!egn || !birthDate) {
        logger.error("Invalid input: EGN or birth date is missing.");
        return false;
    }

    const year = parseInt(egn.substring(0, 2), 10);
    let month = parseInt(egn.substring(2, 4), 10);
    const day = parseInt(egn.substring(4, 6), 10);

    let fullYear;
    if (month > 40) {
        fullYear = 2000 + year;
        month -= 40;
    } else if (month > 20) {
        fullYear = 1800 + year;
        month -= 20;
    } else {
        fullYear = 1900 + year;
    }

    let birthDateDayjs = dayjs(birthDate);
    if (!birthDateDayjs.isValid()) {
        birthDateDayjs = dayjs(birthDate, "YYYY-MM-DD");
        if (!birthDateDayjs.isValid()) {
            logger.error("Invalid birth date format.");
            return false;
        }
    }

    return birthDateDayjs.year() === fullYear &&
        birthDateDayjs.month() + 1 === month &&
        birthDateDayjs.date() === day;
}

export function getMedicalStaffFormComponent( userOrganization?: Organization): ComponentType<any> {
    return userOrganization?.country === 'BG' ? MedicalStaffForm : MedicalStaffFormForeign;
}

